export const string = {
	hex: 'Este campo debe ser un color Hex.',
	unsecure_url: 'No se permiten URL sin https.',
	min: {
		'1': 'Este campo no puede tener menos de 1 carácter.',
		'3': 'Este campo no puede tener menos de 3 caracteres.',
		'5': 'Este campo no puede tener menos de 5 caracteres.',
		'10': 'Este campo no puede tener menos de 10 caracteres.',
		'12': 'Este campo no puede tener menos de 12 caracteres.'
	},
	max: {
		'8': 'Este campo no puede tener más de 8 caracteres.',
		'13': 'Este campo no puede tener más de 13 caracteres.',
		'20': 'Este campo no puede tener más de 20 caracteres.',
		'40': 'Este campo no puede tener más de 40 caracteres.',
		'64': 'Este campo no puede tener más de 64 caracteres.',
		'255': 'Este campo no puede tener más de 255 caracteres.',
		'300': 'Este campo no puede tener más de 300 caracteres.',
		'1000': 'Este campo no puede tener más de 1000 caracteres.',
		'10000': 'Este campo es demasiado largo.'
	},
	length: {
		'10': 'Este campo debe tener 10 caracteres.',
		'16': 'Este campo debe tener 16 caracteres.'
	}
};

export const number = {
	invalid_type: 'Este campo debe ser un número.',
	positive: 'Este número debe ser positivo.',
	min: {
		'0': 'Este número no puede ser menor a 0.',
		'1': 'Este número no puede ser menor a 1.',
		'23': 'Este número no puede ser menor a 23.',
		'150': 'Este número no puede ser menor a 150.'
	},
	max: {
		'3': 'Este número no puede ser mayor a 3.',
		'12': 'Este número no puede ser mayor a 12.',
		'30': 'Este número no puede ser mayor a 30.',
		'99': 'Este número no puede ser mayor a 99.',
		'100': 'Este número no puede ser mayor a 100.',
		'1000': 'Este número no puede ser mayor a 1000.',
		'10000': 'Este número no puede ser mayor a 10000.',
		'50000': 'Este número no puede ser mayor a 50000.',
		'100000': 'Este número no puede ser mayor a 100000.',
		'999999999999999': 'Este número no puede ser mayor a 999999999999999.'
	}
};

export const enums = {
	invalid_type: 'Es necesario especificar un(a)',
	invalid_enum_value: 'Este valor no corresponde con las opciones dadas.',
	default: 'Este valor no corresponde con las opciones dadas.'
};

export const date = {
	default: 'Fecha inválida.'
};

export const general = {
	field_required: 'Este campo es obligatorio.',
	invalid_format: 'El formato de este campo es invalido.',
	invalid_time: 'El formato de hora es invalido.',
	token_8: 'Este campo debe tener 8 caracteres.'
};
